import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { buttonStyle3 } from '../utils/commonStyle';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
function HeaderDropDownMenu({ menus, onSelectMenu,menuButtonName }) {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (value) => {
    onSelectMenu(value);
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        className="!mr-[16px] !capitalize"
        sx={buttonStyle3}
        style={{
          backgroundColor: theme.palette.secondary.main,
          color: 'rgba(255, 255, 255, 1)',
        }}
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="contained"
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      >
        {menuButtonName}
      </Button>
      <Menu
        className='mt-[6px]'
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {menus.map((menu, index) => <MenuItem className='ff-Roboto fs-12 fw-regular black' key={index} onClick={() => {
          handleClose(menu.value)
        }}>{menu.label}</MenuItem>)}
      </Menu>
    </div>
  );
}

export default HeaderDropDownMenu;